import React from "react";
import { TIPOLOGIE } from ".";
import { HomeGradimentoSenologia } from "./senologia";
import { HomeGradimentoColon } from "./coloneRetto";


const HomeGradimento = ({ tipologia }) => {  
  switch (tipologia.KID) {
    case TIPOLOGIE.SENOLOGIA.KID: return <HomeGradimentoSenologia tipologia={tipologia} />;
    case TIPOLOGIE.COLON_RETTO.KID: return <HomeGradimentoColon tipologia={tipologia} />;
    default: return <>NESSUNA TIPOLOGIA</>
  }
}

export default HomeGradimento;